import Burger from '../../images/burger.png';
import Beer from '../../images/beer.png';
import Burrito from '../../images/burrito.png';
import Fritto from '../../images/deep-fryer.png';
import DrinkAlcolic from '../../images/drinkalcol.png';
import DrinkNOAlcolic from '../../images/drinkNOalcol.png';
import Grocery from '../../images/grocery.png';
import Liquor from '../../images/liquor.png';
import Sandwich from '../../images/sandwich.png';
import Sauce from '../../images/sauces.png';
import SoftDrink from '../../images/soft-drink.png';
import Plate from '../../images/steak.png';
import Water from '../../images/water.png';

import BottigliaVino from '../../images/bottigliaVino.png';
import CaliceProsecco from '../../images/caliceProsecco.png';
import CaliceVino from '../../images/caliceVino.png';
import Caffe from '../../images/coffee.png';
import ConoGelato from '../../images/conoGelato.png';
import Gelato from '../../images/gelato.png';
import Gin from '../../images/gin.png';
import Prosecco from '../../images/prosecco.png';
import Tea from '../../images/tea.png';
import Tagliere from '../../images/tagliere.png';
import Spiedini from '../../images/spiedini.png';
import Aperitivo from '../../images/aperitivo.png';
import Pizza from '../../images/pizza.png';
import Rum from '../../images/rum.png';
import Whisky from '../../images/whisky.png';

const imageMap = {
    burger: Burger,
    birra: Beer,
    burrito: Burrito,
    fritto: Fritto,
    drinkAlcolic: DrinkAlcolic,
    drinkNOAlcolic: DrinkNOAlcolic,
    grocery: Grocery,
    liquore: Liquor,
    sandwich: Sandwich,
    sauce: Sauce,
    softDrink: SoftDrink,
    plate: Plate,
    water: Water,
    bottigliaVino: BottigliaVino,
    caliceProsecco: CaliceProsecco,
    caliceVino: CaliceVino,
    caffe: Caffe,
    conoGelato: ConoGelato,
    gelato: Gelato,
    gin: Gin,
    prosecco: Prosecco,
    tea: Tea,
    tagliere: Tagliere,
    spiedini: Spiedini,
    aperitivo: Aperitivo,
    pizza: Pizza,
    rum: Rum,
    whisky: Whisky,
};

export default imageMap;
